export const AUTO_SCALING_OFF_ATTRIBUTE = 'data-auto-scaling-off';

export const syncAutoScalingState = (autoScalingOff: boolean) => {
  const { documentElement } = document;

  if (autoScalingOff) {
    documentElement.setAttribute(AUTO_SCALING_OFF_ATTRIBUTE, 'true');
    return;
  }

  documentElement.removeAttribute(AUTO_SCALING_OFF_ATTRIBUTE);
};